export default __webpack_public_path__ + "static/media/applications-image-19.15ea5dd8.jpg";